import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductsService } from '../../../services/products.service';
import { Product } from '../../../models/Product';
import { ErrorService } from '../../../shared/services/error.service';

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.css']
})
export class ProductViewComponent implements OnInit {
  product: Product | null = null;
  isLoading = false;
  productId: number | null = null;

  // Opções para tradução de tipos
  productTypes = [
    { value: 'Plan', label: 'Plano' },
    { value: 'Service', label: 'Serviço' },
    { value: 'Product', label: 'Produto' },
    { value: 'Subscription', label: 'Assinatura' }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productsService: ProductsService,
    private messageService: ErrorService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.productId = +params['id'];
        this.loadProduct();
      }
    });
  }

  loadProduct(): void {
    if (!this.productId) return;

    this.isLoading = true;
    this.productsService.getProduct(this.productId).subscribe({
      next: (product) => {
        this.product = product;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar produto:', error);
        this.isLoading = false;
        this.messageService.showErrorMessage('Erro ao carregar produto. Tente novamente.');
        this.router.navigate(['/products']);
      }
    });
  }

  navigateToEdit(): void {
    if (this.productId) {
      this.router.navigate(['/products', this.productId, 'edit']);
    }
  }

  navigateBack(): void {
    this.router.navigate(['/products']);
  }

  formatPrice(price: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  }

  formatDays(days: number): string {
    if (days === 1) return '1 dia';
    return `${days} dias`;
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getStatusBadgeClass(isActive: boolean): string {
    return isActive ? 'badge-success' : 'badge-secondary';
  }

  getStatusText(isActive: boolean): string {
    return isActive ? 'Ativo' : 'Inativo';
  }

  getTypeBadgeClass(type: string): string {
    const typeClasses: { [key: string]: string } = {
      'Plan': 'badge-primary',
      'Service': 'badge-info',
      'Product': 'badge-warning',
      'Subscription': 'badge-success'
    };
    return typeClasses[type] || 'badge-secondary';
  }

  getTypeText(type: string): string {
    const typeOption = this.productTypes.find(t => t.value === type);
    return typeOption ? typeOption.label : type;
  }
}
